import { ResizeSensor } from "css-element-queries";

let pageOffset = 400;
if (header_offset_scroll) {
  pageOffset = header_offset_scroll;
}

jQuery(document).ready(function ($) {
  let haveOverlay = false;

  if ($("#gpt-ad-atf-overlay > div > iframe").length !== 0) {
    if (
      $("#gpt-ad-atf-overlay > div > iframe").hasClass("dfp-skin__container")
    ) {
      haveOverlay = true;
      if ($(window).outerWidth() >= 1024) {
        $(".wrapper").addClass("is-overlay-on");
        $("body").addClass("is-overlay-on");
      }
    } else {
      $("body").addClass("is-skinning-on");
    }
  }

  function headerAdTimeOut(time) {
    setTimeout(() => {
      if ($(window).scrollTop() > 0) {
        $(".wrapper").css(
          "padding-top",
          `${$(".header-wrapper").outerHeight()}px`
        );
        $(".header-wrapper").addClass("is-fixed");
      }
      if ($(window).scrollTop() >= pageOffset) {
        $(".header-wrapper")
          .css("transform", `translateY(-${$(".header-ad").outerHeight()}px)`)
          .css("transition", "all .7s");

        $(".wrapper").addClass("is-transformed");
      }
    }, time);
  }

  function overlayAdTimeOut(time) {
    setTimeout(() => {
      if ($(window).outerWidth() >= 1024) {
        // if(!haveOverlay)
        $(".wrapper").css(
          "margin-top",
          `${$("#gpt-ad-atf-overlay").outerHeight()}px`
        );
        if ($(window).scrollTop() == 0) {
          $(".header-wrapper").removeClass("is-fixed");
        }
      }

      if ($("#gpt-ad-atf-overlay > div > iframe").length !== 0) {
        if (
          $("#gpt-ad-atf-overlay > div > iframe").hasClass(
            "dfp-skin__google-iframe"
          )
        ) {
          haveOverlay = true;
          if ($(window).outerWidth() >= 1024) {
            $(".wrapper").addClass("is-overlay-on");
            $("body").addClass("is-overlay-on");
            $(".header-wrapper").css("transform", "none");
          }
        } else {
          $("body").addClass("is-skinning-on");
        }
      }
    }, time);
  }

  if (!haveOverlay)
    new ResizeSensor(jQuery("#gpt-ad-atf-lb"), function () {
      headerAdTimeOut(1);
      headerAdTimeOut(1000);
      headerAdTimeOut(2000);
      headerAdTimeOut(3000);
      headerAdTimeOut(4000);
      headerAdTimeOut(5000);
      headerAdTimeOut(6000);
    });

  new ResizeSensor(jQuery("#gpt-ad-atf-overlay"), function () {
    overlayAdTimeOut(1);
    overlayAdTimeOut(4000);
    overlayAdTimeOut(6000);
    overlayAdTimeOut(8000);
    overlayAdTimeOut(10000);
  });

  $(window).on("scroll", function () {
    let isMobile = $(window).outerWidth() <= 480;

    if ($(window).outerWidth() >= 1024 && haveOverlay) {
      if (
        $(window).scrollTop() >=
        parseInt($(".wrapper").css("margin-top").split("px")[0])
      ) {
        $(".header-wrapper").addClass("is-fixed");
        $(".wrapper").css("padding-top", $(".header-wrapper").outerHeight());
      } else {
        $(".header-wrapper").removeClass("is-fixed");
        $(".wrapper").css("padding-top", "0");
      }

      if ($(window).scrollTop() == 0) {
        $(".header-wrapper").removeClass("is-fixed");
      }
    } else {
      let dfpSkin = $("body").hasClass("dfp-skin");
      if (!dfpSkin) {
        if (!isMobile) {
          $(".wrapper").css(
            "padding-top",
            `${$(".header").outerHeight() + 45}px`
          );
        } else {
          $(".wrapper").css(
            "padding-top",
            `${$(".header-wrapper").outerHeight()}px`
          );
        }

        if ($(window).scrollTop() > 0) {
          $(".header-wrapper").addClass("is-fixed");
          if (!isMobile) {
            $(".header-wrapper")
              .css(
                "transform",
                `translateY(-${$(".header-ad").outerHeight()}px)`
              )
              .css("transition", "all .7s");

            $(".wrapper").addClass("is-transformed");
          }
        } else {
          $(".wrapper").css("padding-top", "0");
          $(".header-wrapper").removeClass("is-fixed");
          if (!isMobile) {
            $(".header-wrapper").css("transform", `translateY(0)`);
            $(".wrapper").removeClass("is-transformed");
          }
        }

        if (isMobile) {
          if ($(window).scrollTop() >= pageOffset) {
            $(".header-wrapper")
              .css(
                "transform",
                `translateY(-${$(".header-ad").outerHeight()}px)`
              )
              .css("transition", "all .7s");

            $(".wrapper").addClass("is-transformed");
          } else {
            $(".header-wrapper").css("transform", `translateY(0)`);
            $(".wrapper").removeClass("is-transformed");
          }
        }
      } else {
        if ($(window).scrollTop() > 250) {
          $(".header-wrapper").addClass("is-fixed");
          $(".header-ad").css("height", 0);
          $(".header-ad").css("min-height", 0);
          $(".dfp-skin__content").css("height", "0");
        } else {
          $(".wrapper").css("padding-top", "0");
          $(".header-wrapper").removeClass("is-fixed");
          $(".header-wrapper").css("transform", `translateY(0)`);
          $(".wrapper").removeClass("is-transformed");
          $(".header-ad").css("height", "auto");
          $(".header-ad").css("min-height", "130px");
          $(".dfp-skin__content").css("height", "250px");
        }
      }
      return null;
    }
  });

  $(window).on("resize", function () {
    $(".wrapper").css("padding-top", `${$(".header-wrapper").outerHeight()}px`);
    if ($(window).scrollTop() == 0) {
      $(".wrapper").css("padding-top", 0);
    }
  });
});
